import MorphIpad from './MorphIpad'

export default MorphIpad
